import {
    assignNewUser,
    createApplication,
    createNotes,
    fetchLogs,
    fetchNotes,
    getSingleApplication,
    getStatusCount,
    listApplication,
    saveApplication,
    updateApplication,
    updateApplicationStatus
} from "../../../redux/slices/applicationSlice";
import { useApiCall } from "../../common/useApiCall"

export const useApplicationApi = () => {
    const apiCall = useApiCall();

    const saveApplicationData = (data, onSuccess, onError) => {
        apiCall(saveApplication.type, data, onSuccess, onError);
    }
    const addApplication = (data, onSuccess, onError) => {
        apiCall(createApplication.type, data, onSuccess, onError);
    }

    const changeApplicationStatus = (data, onSuccess, onError) => {
        apiCall(updateApplicationStatus.type, data, onSuccess, onError);
    }

    const fetchApplication = (data, onSuccess, onError) => {
        apiCall(listApplication.type, data, onSuccess, onError);
    }

    const fetchStatusCount = (data, onSuccess, onError) => {
        apiCall(getStatusCount.type, data, onSuccess, onError);
    }

    const fetchSingleApplication = (data, onSuccess, onError) => {
        apiCall(getSingleApplication.type, data, onSuccess, onError);
    }

    const editApplication = (data, onSuccess, onError) => {
        apiCall(updateApplication.type, data, onSuccess, onError);
    }

    const assignUserToApplication = (data, onSuccess, onError) => {
        apiCall(assignNewUser.type, data, onSuccess, onError);
    }

    const createNewNote = (data, onSuccess, onError) => {
        apiCall(createNotes.type, data, onSuccess, onError);
    }

    const fetchAllNotes = (data, onSuccess, onError) => {
        apiCall(fetchNotes.type, data, onSuccess, onError);
    }

    const fetchActivityLogs = (data, onSuccess, onError) => {
        apiCall(fetchLogs.type, data, onSuccess, onError);
    }

    




    return {
        saveApplicationData,
        addApplication,
        fetchApplication,
        fetchStatusCount,
        fetchSingleApplication,
        changeApplicationStatus,
        editApplication,
        assignUserToApplication,


        createNewNote,
        fetchAllNotes,
        fetchActivityLogs
    }
}